<template>
  <!-- <div class="svg-wrapper"> -->
    <svg xmlns="http://www.w3.org/2000/svg" :fill="translateColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>
    </svg>
  <!-- </div> -->
</template>

<script>
export default {
  name: 'ArrowRightIcon',
  props: {
    color: {
      type: String,
      default: 'currentColor',
    },
  },
  computed: {
    translateColor() {
      if (this.color === 'normal') {
        return '#0F6352';
      } if (this.color === 'warning') {
        return '#955300';
      } if (this.color === 'danger') {
        return '#B72424';
      }
      return this.color;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
